'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { GalleryProps } from '../../pages/gallery/page';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useState } from 'react';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const Gallery = ({ gallery }: { gallery: GalleryProps[] }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<string[]>([]);
  const [visibleCount, setVisibleCount] = useState(8);

  const handleOpenGallery = (gallery: GalleryProps[], index: number) => () => {
    if (gallery && gallery.length > 0 && index >= 0 && index < gallery.length) {
      const selectedImage = gallery[index];
      const reorderedImages = [
        selectedImage,
        ...gallery.slice(index + 1),
        ...gallery.slice(0, index),
      ];
      setImagesSorted(reorderedImages.map(image => image.image));
      setIsOpen(true);
    }
  };

  const getColumnSpan = (index: number) => {
    if (index === 0) return 'col-span-12';
    const patternIndex = (index - 1) % 5;
    return patternIndex === 0 || patternIndex === 1 ? 'sm:col-span-6' : 'sm:col-span-4';
  };

  const showMoreImages = () => {
    setVisibleCount(prevCount => prevCount + 8);
  };

  const { t } = useTranslations();

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <section className={cn('custom-section', 'my-16')}>
        <div className={cn('custom-container', 'grid grid-cols-12 gap-2 lg:gap-8')}>
          {gallery.slice(0, visibleCount).map((image, index) => (
            <button
              type="button"
              aria-label={`${t('text2246')} ${index + 1}`}
              key={index}
              onClick={handleOpenGallery(gallery, index)}
              className={cn(
                'relative col-span-12 aspect-video w-full cursor-pointer border-0 bg-transparent p-0',
                getColumnSpan(index),
              )}
            >
              <Image
                src={image.image.url}
                alt={resolveImageAlt(image?.image, undefined)}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                sizes="(min-width: 640px) 50vw, 100vw"
              />
            </button>
          ))}
        </div>
        {visibleCount < gallery.length && (
          <div className="mt-4 text-center">
            <Button onClick={showMoreImages}>{t('text3378')}</Button>
          </div>
        )}
      </section>
    </>
  );
};
